export const BILLING_STATUS = {
    NONE: "none",
    ACTIVE: "active",
    INCOMPLETE: "incomplete",
    TRIALING: "trialing",
    PAST_DUE: "past_due",
    CANCELED: "canceled",
    DISABLED: "disabled",
    ENTERPRISE_INVOICED: "enterprise_invoiced",
};
